<template>
    <div class="content">
        <div class="title" style="display: block; line-height: 40px;background: #fff;margin-bottom: 24px">
            App中本地有保留(常用/不常用)分组,请不要重复
        </div>
        <div class="searchContent">
            <div class="p_select" style="float: right">
                <el-button class="add_btn" @click="addGroup"><i class="el-icon-plus"></i>新增</el-button>
            </div>
        </div>
        <div class="list_content">
            <el-table :data="groupListData" :height="winHeight"  @row-dblclick="changeGroupDataToRight" style="width: 48%; float: left" >
                <el-table-column prop="positionGroupId" label="ID" ></el-table-column>
                <el-table-column prop="positionGroupName" label="分组名称"></el-table-column>
                <el-table-column fixed="right" label="操作" width="400" >
                    <template slot-scope="scope">
                        <el-button
                                @click="updateGroupName(scope.row)"
                                class="update_btn"
                                size="small"
                        >修改名称</el-button>
                        <el-button
                                @click="updatePosition(scope.row)"
                                class="update_btn"
                                size="small"
                        >增 / 删部位</el-button>
                        <el-button
                                @click="deletePositionGroup(scope.row)"
                                class="update_btn"
                                size="small"
                        >删除分组</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <p style="margin-bottom: 10px;font-size:24px;font-weight:700">{{positionGroupNameTitle}}</p>
            <el-table :data="positionListData" :height=winHeight style="width: 48%; float: right" >
                <el-table-column prop="positionId" label="部位ID" ></el-table-column>
                <el-table-column prop="positionName" label="部位名称" ></el-table-column>
            </el-table>
        </div>

        <el-drawer
                title="新增分组"
                :visible.sync="showAddGroup"
                direction="rtl"
                :wrapperClosable=true
        >
            <el-form  label-width="100px">
                <el-form-item label="分类名称:">
                    <el-input v-model="positionGroupName" placeholder="请输入少于五个字的分类名称" ></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAddGroup">确认新增</a>
                <a class="cancel_btn" @click="showAddGroup = false">取消</a>
            </div>
        </el-drawer>


        <el-dialog :visible.sync="showUpdatePosition" title="修改分组部分" width="40%" :close-on-click-modal="false" center @close="cancelUpdatePosition" >
            <div class="update_position">

                <el-checkbox-group v-model="checkPositionList">
                    <el-checkbox v-for="checkPosition in positionList"
                                 :label="checkPosition.positionId*1"
                                 :value="checkPosition.positionId*1"
                                 :key="checkPosition.positionId*1" >
                        {{checkPosition.positionName}}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelUpdatePosition">取 消</el-button>
                <el-button type="primary" @click="sureUpdatePosition">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="showUpdateName" title="修改分组名称" width="40%" >
            <div class="update_position">
                <el-input v-model="editPositionGroupName" placeholder="请输入少于五个字的分组名称" ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showUpdateName = false">取 消</el-button>
                <el-button type="primary" @click="sureUpdatePositionName">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    name: "positionGroup",
    data(){
      return {
        signInfo:'',

        positionList:[], //部位
        groupListData:[],
        showAddGroup :false,
        positionGroupName : '',
        groupTitle:'新增分组名称',

        positionListData:[],
        showUpdatePosition: false,
        positionGroupNameTitle:'',
        checkPositionList: [],

        isIndeterminate: true,
        checkAll: false,
        positionGroupId:'', //选中行的ID
        winHeight:'220',

        editPositionGroupName: '',
        showUpdateName: false,
        rowData: ''
      }
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.signInfo = signInfo
      this.getPositionList()
      this.queryGroup()
    },
    methods:{
      // 获取站点所有部位
      getPositionList(callback) {
        let that = this;
        const params = {
          orgId: this.signInfo.orgId,
          showType: 0,
        }
        net.request("admin/manage/parts/getPositionList", "post", params).then(res => {
          if (res.code === 0) {
            this.positionList = res.data
            let tag = false;
            if (callback && this.positionList != null && this.positionList.length > 0) {
              this.positionList.forEach(function (e) {
                if (e.positionId === that.positionId) {
                  tag = true;
                }
              });
            }
            if (!tag) {
              that.positionId = ''
              that.templateListData = []
              that.total = 0
              that.pageNo = 0
            }
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },

      queryGroup(){
        net.request("admin/manage/positionGroup/queryGroup","post",{orgId: this.signInfo.orgId}).then(res => {
          if (res.code === 0) {
            let data = res.data
            this.groupListData = data
            if(data.length > 0){
              if(this.positionGroupId){ // 修改某行
                for(let i = 0; i < data.length; i++){
                  if(data[i].positionGroupId == this.positionGroupId){
                    this.positionListData = data[i].positionGroupContentList
                    this.positionGroupNameTitle = data[i].positionGroupName
                  }
                }
              }else { // 默认显示第一行
                this.positionListData = res.data[0].positionGroupContentList
                this.positionGroupNameTitle = res.data[0].positionGroupName
              }
            }

            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
            this.winHeight = windiwHight - 270;
          } else {
            net.message(this, res.msg, "warning")
          }
        })
      },
      addGroup(){
        this.showAddGroup = true
        this.positionGroupName = ''
      },
      submitAddGroup(){
        if(this.positionGroupName.length > 5 || this.positionGroupName.length < 0){
          net.message(this, '请输入少于五个字的分类名称', "warning")
          return
        }else {
          const params = {
            orgId: this.signInfo.orgId,
            positionGroupName: this.positionGroupName
          }
          net.request("admin/manage/positionGroup/updateOrgPositionGroup","post",null, params).then(res => {
            if (res.code === 0) {
              net.message(this, res.msg, "success")
              this.showAddGroup = false
              this.queryGroup()
            } else {
              net.message(this, res.msg, "warning")
            }
          })
        }
      },
      // 双击
      changeGroupDataToRight(row){
        let groupListData = this.groupListData
        let positionGroupId = row.positionGroupId
        for(let i = 0; i < groupListData.length; i++){
          if(positionGroupId*1 == groupListData[i].positionGroupId * 1){
            this.positionListData = groupListData[i].positionGroupContentList
            this.positionGroupNameTitle = groupListData[i].positionGroupName
          }
        }
      },
      // 删除分组
      deletePositionGroup(row){
        let positionGroupId = row.positionGroupId
        this.$confirm('此操作将删除  '+row.positionGroupName+'  分组, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          net.request("admin/manage/positionGroup/deletePositionGroup","post",{positionGroupId:positionGroupId}).then(res => {
            if (res.code === 0) {
              net.message(this, res.msg, "success")
              this.queryGroup()
            } else {
              net.message(this, res.msg, "warning")
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      // 修改部位
      updatePosition(row){
        this.showUpdatePosition = true
        let positionList = this.positionList //所有部位
        let positionGroupContentList = row.positionGroupContentList //修改的行
        this.positionGroupId = row.positionGroupId //行ID

        let arr = this.checkPositionList
        for(let j = 0; j < positionGroupContentList.length; j++){
          for(let i = 0; i < positionList.length; i++ ){
            if(positionGroupContentList[j].positionId*1 === positionList[i].positionId*1){
              arr.push(positionGroupContentList[j].positionId*1)
            }
          }
        }
        this.checkPositionList = arr
      },
      // 确定
      sureUpdatePosition(){
        let checkPositionList = this.checkPositionList
        net.request("admin/manage/positionGroup/updatePositionGroupInfoList","post",{positionGroupId:this.positionGroupId}, checkPositionList).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success")
            this.showUpdatePosition = false
            this.checkPositionList = []
            this.queryGroup()

          } else {
            net.message(this, res.msg, "warning")
          }
        })
      },
      // 取消
      cancelUpdatePosition(){
        this.showUpdatePosition = false
        this.checkPositionList = []
      },

      // 修改名称
      updateGroupName(row){
        this.showUpdateName = true
        this.editPositionGroupName = row.positionGroupName
        this.rowData = row
      },
      sureUpdatePositionName(){
        if(this.editPositionGroupName.length > 5 || this.editPositionGroupName.length < 0){
          net.message(this, '请输入少于五个字的分类名称', "warning")
          return
        }else {
          const params = {
            orgId: this.signInfo.orgId,
            positionGroupName: this.editPositionGroupName,
            positionGroupId: this.rowData.positionGroupId
          }
          net.request("admin/manage/positionGroup/updateOrgPositionGroup","post",null, params).then(res => {
            if (res.code === 0) {
              net.message(this, res.msg, "success")
              this.showUpdateName = false
              this.queryGroup()
            } else {
              net.message(this, res.msg, "warning")
            }
          })
        }
      },

    }
  };
</script>


<style lang='less' scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    .content {
        padding-left: 24px;
        .title {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background: #eaeefb;
            /*color: red;*/
            font-size: 20px;
            font-weight: 700;
        }
        .searchContent {
            height: 60px;
            background: #fff;
            margin: 24px 0 0px 0;
            /*display: flex;*/
            /*flex-direction: row;*/
            padding-left: 24px;
            padding-top: 24px;
            .p_select {
                display: flex;
                padding: 0 24px 24px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                width: 76px;
                height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                width: 76px;
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
            overflow: hidden;
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #009688;
    }

    .select_box {
        text-align: left;
        margin-bottom: 10px;

        .select_title {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;
        }
    }

    .el-image__inner {
        width: 32px;
        height: 44px;
        line-height: 1;
        text-align: center;
        vertical-align: bottom;
    }

    .print_table {
        border: 1px dashed #333;
    }

    #printBoxList {
        /deep/.el-table .el-table__footer-wrapper .el-table__cell {
            border-top: 1px dashed #000;

            .cell {
                color: #000;
            }
        }
    }
    .update_position .el-checkbox {
        width: 29%;
        margin: 6px 0;
    }
    .update_btn {
        width: 90px;
        height: 28px;
        background: rgba(148, 170, 204, 0.08);
        border: 1px solid #E3E7ED;
        border-radius: 14px;
        font-size: 12px;
        color: #364556;
        text-align: center;
    }
</style>
